/***********************************************************************
 * INTERFACE
 **********************************************************************/
export interface RadioOption {
  label: string;
  value: any;
  selected: boolean;
}

export interface CheckboxOption {
  label: string;
  value: any;
  selected: boolean; // Whether the checkbox is selected or not
}

export interface DropDown {
  id: number;
  name: string;
}

export class GlobalAppConstants {
  public static vehicleBrand: DropDown[] = [
    { id: 1, name: 'Renault' },
    { id: 2, name: 'Nissan' },
    // Add more options as needed
  ];

  public static cpModuleList: CheckboxOption[] = [
    { label: '1', value: 'CAR_MAINTENANCE', selected: false },
    { label: '2', value: 'DRIVER_FEEDBACK', selected: false },
    { label: '3', value: 'HOUSE_MAINTENANCE', selected: false },
    { label: '4', value: 'HOUSE_RELOCATION', selected: false },
    // Add more options as needed
  ];

  public static FuelMakeArray: CheckboxOption[] = [
    { label: 'Petrol', value: 'petrol', selected: false },
    { label: 'Diesel', value: 'diesel', selected: false },
    { label: 'Electric', value: 'electric', selected: false },
    // Add more options as needed
  ];

  public static fuelTypeArray: RadioOption[] = [
    { label: 'Petrol', value: 'petrol', selected: false },
    { label: 'Diesel', value: 'diesel', selected: false },
    { label: 'Electric', value: 'electric', selected: false },
    // Add more options as needed
  ];

  public static vehicleType: RadioOption[] = [
    { label: 'Admin', value: 'admin', selected: false },
    { label: 'Office', value: 'office', selected: false },
    { label: 'Family', value: 'family', selected: false },
    { label: 'VIP', value: 'vip', selected: false },
    // Add more options as needed
  ];

  public static vendorTypeArray: DropDown[] = [
    { id: 1, name: 'Home' },
    { id: 2, name: 'Car' },
    { id: 3, name: 'Relocation' },
    // Add more options as needed
  ];

  public static statusArray: DropDown[] = [
    { id: 1, name: 'Active' },
    { id: 2, name: 'InActive' },
    // Add more options as needed
  ];

  public static renaultBrand: DropDown[] = [
    { id: 1, name: 'Kiger' },
    { id: 2, name: 'Duster' },
    { id: 2, name: 'Capture' },
    // Add more options as needed
  ];

  public static nissanBrand: DropDown[] = [
    { id: 1, name: 'Magnite' },
    { id: 2, name: 'kick' },
    // Add more options as needed
  ];

  public static RequestStatus: DropDown[] = [
    { id: 1, name: 'ACKNOWLEDGED' },
    { id: 2, name: 'REJECTED' },
    { id: 3, name: 'IN_PROGRESS' },
    { id: 4, name: 'COMPLETED' },
  ];
}
